/**
 * @author zhushitao@bytedance.com
 * @date 2021-03-11
 */
import LinkchatRender from './lib/index';
import Load from './components/PageLoading';
export { LayoutEventBus } from './constants/eventBus';

export { revetPxToRem } from './lib/rem';
export { Icon } from './components/Icon';
export { Load };
export default LinkchatRender;
